import { Button, Grid, Skeleton, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

export default function GridMenu({items, loading, acf}){

    return(
        <Container maxWidth='xl'>
            <Box
                sx={{
                    m:'3rem 0'
                }}
            >
                <Grid container spacing={2}>
                    {loading?
                        Array(4).fill(0).map(()=>{
                            return(
                                <Grid item xs={12} md={6}>
                                    <Skeleton 
                                        variant="rectangular"
                                        height='300px'
                                    />
                                </Grid>
                            )
                        })
                    :
                        items && items.map((item)=>{
                            return(
                                <Grid item xs={12} md={12/items.length}>
                                    <Button
                                        component={RouterLink}
                                        to={item.url}
                                        sx={{
                                            p:0,
                                            position:'relative',
                                            width:'100%',
                                            height:'100%',
                                        }}
                                    >
                                        <img
                                            src={item.image.url}
                                            alt={item.image.alt}
                                            width='100%'
                                            height='100%'
                                            style={{
                                                maxHeight:'300px',
                                                objectFit:'cover'
                                            }}
                                        />
                                        <Box
                                            sx={{
                                                position:'absolute',
                                                height:'100%',
                                                width:'100%',
                                                display:'flex',
                                                alignItems:'flex-end',
                                                p:'1rem',
                                                transition:'background-color 0.25s',
                                                '&:hover':{
                                                    backgroundColor:'rgba(53, 92, 160, 0.2)',
                                                }
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    backgroundColor:'rgba(256,256,245,0.9)',
                                                    p:'1rem'
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color:'#265DA5',
                                                        fontWeight:600,
                                                        fontSize:'1.2rem'
                                                    }}
                                                >
                                                    {item.title}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Button>
                                </Grid>
                            );
                        })
                    }
                </Grid>

                {/* {acf?.call_to_action &&
                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', padding: '2rem 0 0 0' }}>
                        <Typography
                            variant='h2'
                            component={'h2'}
                            sx={{
                                color: '#1B314A',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                margin: '2rem 0'
                            }}
                        >
                            {acf?.call_to_action?.title}
                        </Typography>
  
                        <Button
                            component={RouterLink}
                            to={acf?.call_to_action?.link}
                            sx={{
                                p: '0.5rem 2rem',
                                borderRadius: '2rem',
                                color: '#fff',
                                fontSize: '1rem',
                                backgroundColor: '#E9531C',
                            }}
                        >
                            {acf?.call_to_action?.button_label}
                        </Button>
                    </Box>
                } */}
            </Box>
        </Container>
    );
}